import toast from "react-hot-toast";
import { appAPI } from "../../../api/service";

export function useUpdateSettings({unsavedChanges, setNavigation, setUnsavedChanges, setUserInfo}) {

    const handleSaveChanges = async () => {
        try {
          const data = {
            action: `editsettings`,
            settings: {},
          };
          unsavedChanges.map((item) => (data.settings[item.data] = item.pkey));
          const res = await appAPI.saveSettings(data);
          if (res.error) {
            if (res.error === "Invalid JWT token") {
              return setUserInfo(false);
            }
            return toast.error(res.error);
          }
          
          toast.success("Изменения сохранены");
    
          setNavigation((prev) =>
            prev.map((item) => {
              if (item.current) {
                return {
                  ...item,
                  dataForRender: item.dataForRender.map((i) => {
                    if (unsavedChanges.find((item) => item.data === i.data)) {
                      console.log(i.value);
                      console.log(i.toBackend);
                      return {
                        ...i,
                        value: i.toBackend,
                      };
                    }
                    return { ...i };
                  }),
                };
              }
              return item;
            })
          );
    
          setUnsavedChanges({});
        } catch (error) {
          console.log(error);
          toast.error("Ошибка при сохранении изменений");
        }
      };

    return {
        handleSaveChanges
    }
}